import script from "./MicroFilterMobileAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./MicroFilterMobileAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./MicroFilterMobileAccordion.vue?vue&type=style&index=0&id=3693b526&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3693b526"]])

export default __exports__